var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5502 7.85234C19.5502 3.87493 16.9441 2.70984 16.9441 2.70984C15.6305 2.10668 13.3746 1.85276 11.0307 1.83351H10.9729C8.62902 1.85276 6.37493 2.10668 5.06043 2.70984C5.06043 2.70984 2.45435 3.87584 2.45435 7.85234C2.45435 8.76259 2.43693 9.85159 2.46535 11.0066C2.55977 14.896 3.17852 18.7295 6.7746 19.681C8.43285 20.1201 9.85643 20.2118 11.0023 20.1485C13.0813 20.033 14.2482 19.4069 14.2482 19.4069L14.1794 17.8981C14.1794 17.8981 12.6935 18.3665 11.0252 18.3097C9.37152 18.2528 7.6271 18.1318 7.35943 16.1014C7.33416 15.9127 7.3219 15.7225 7.32277 15.5322C7.32277 15.5322 8.94527 15.9291 11.0023 16.0235C12.2599 16.0813 13.4388 15.9502 14.6369 15.8072C16.934 15.5331 18.9342 14.1178 19.1854 12.8243C19.5832 10.7866 19.5502 7.85234 19.5502 7.85234ZM16.4766 12.9765H14.569V8.30243C14.569 7.31701 14.1547 6.81743 13.3251 6.81743C12.4084 6.81743 11.9492 7.41051 11.9492 8.58385V11.1423H10.0526V8.58385C10.0526 7.41051 9.59335 6.81743 8.67577 6.81743C7.84618 6.81743 7.43185 7.31793 7.43185 8.30243V12.9765H5.52427V8.16126C5.52427 7.17676 5.77452 6.39484 6.27868 5.81643C6.79752 5.23801 7.47677 4.94101 8.32102 4.94101C9.29727 4.94101 10.037 5.31593 10.5256 6.06668L11.0004 6.86326L11.4762 6.06668C11.9648 5.31593 12.7045 4.94101 13.6808 4.94101C14.5241 4.94101 15.2043 5.23801 15.7231 5.81643C16.2264 6.39484 16.4766 7.17676 16.4766 8.16126V12.9765Z",
    fill: "url(#paint0_linear_64_123)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_64_123",
    x1: 11,
    y1: 1.83351,
    x2: 11,
    y2: 20.1665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6364FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563ACC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMa);
export default __webpack_public_path__ + "static/media/ma.51ff5adb2c1ba8fa03fb52e9608f4431.svg";
export { ForwardRef as ReactComponent };